import React from 'react'
import moment from 'moment'
import { Chip } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { CAMPAIGN_KIND_LABELS } from 'app/ducks/internalCampaigns/constants'

const useStyles = makeStyles(({ palette }) => ({
  hero: {
    display: 'block',
    width: '100%',
    aspectRatio: '16 / 9',
    objectFit: 'cover',
    backgroundColor: palette.action.hover,
  },
  body: {
    padding: '16px 20px 4px',
  },
  meta: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 8,
    marginBottom: 8,
  },
  date: {
    fontSize: 13,
    color: palette.text.secondary,
  },
  title: {
    margin: '0 0 8px',
    fontSize: 20,
    fontWeight: 700,
    lineHeight: 1.3,
  },
  description: {
    margin: 0,
    whiteSpace: 'pre-line',
    color: palette.text.secondary,
    lineHeight: 1.6,
  },
}))

export const formatCampaignDate = (date) =>
  moment(date).format('D [de] MMMM [de] YYYY')

/**
 * The part of a campaign shared by the popup and the Novidades page:
 * hero image, kind/"Novo" tags, date, title and description. The
 * description is plain text rendered as-is (line breaks preserved) — never
 * as HTML.
 */
const InternalCampaignContent = ({ campaign, isNew, titleId }) => {
  const classes = useStyles()

  return (
    <>
      <img
        className={classes.hero}
        src={campaign.hero_image_url}
        alt=""
        data-testid="internal-campaign-hero"
      />
      <div className={classes.body}>
        <div className={classes.meta}>
          <Chip
            size="small"
            variant="outlined"
            label={CAMPAIGN_KIND_LABELS[campaign.kind] || 'Novidade'}
          />
          {isNew && <Chip size="small" color="primary" label="Novo" />}
          <span className={classes.date}>
            {formatCampaignDate(campaign.starts_at)}
          </span>
        </div>
        <h2 id={titleId} className={classes.title}>
          {campaign.title}
        </h2>
        <p className={classes.description}>{campaign.description}</p>
      </div>
    </>
  )
}

export default InternalCampaignContent
